import { useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTracker } from '@dpdgroupuk/react-event-tracker';
import { useDispatch } from 'react-redux';

import { parseQuery, stringifyQuery } from '../utils/query';
import { ROUTES } from '../constants/analytics';
import { setScrollToRoute } from '../store/reducers/routes';

export const useRouteClicks = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const tracker = useTracker();
  const dispatch = useDispatch();

  const onClick = useCallback(
    (route) => {
      const { routeId, detailVisible, ...newQuery } = parseQuery(
        location.search
      );

      if (detailVisible) {
        return;
      }

      const newRouteId = routeId === route.routeId ? undefined : route.routeId;

      navigate({
        search: stringifyQuery({
          ...newQuery,
          routeId: newRouteId,
        }),
      });

      tracker.logEvent(ROUTES.CLICK_ROUTE);
    },
    [location.search, tracker]
  );

  const onDoubleClick = useCallback(
    (route) => {
      const query = parseQuery(location.search);
      const newRouteId = query.detailVisible ? undefined : route.routeId;
      const newDetailVisible = query.detailVisible ? undefined : true;
      if (query.detailVisible) {
        dispatch(setScrollToRoute(route.routeId));
      }
      navigate({
        search: stringifyQuery({
          ...query,
          routeId: newRouteId,
          detailVisible: newDetailVisible,
        }),
      });

      tracker.logEvent(ROUTES.DOUBLE_CLICK_ROUTE);
    },
    [location.search, tracker]
  );

  return [onClick, onDoubleClick];
};
